<template>
    <div>
        <LsTemplatedLoading :show="loading" :full-screen="true" test-id="loading" />
        <div v-if="!loading" class="ls-required_service-view--columns">
            <LsServiceRecOrReqDetails
                :recommendation-or-required="requiredService"
                :services="allRecentAndCurrentServices"
                class="ls-required_service-view--details"
                test-id="required_service_details"
            />
            <div
                v-if="routeName === 'requiredService'"
                class="ls-required_service-view--buttons"
                test-id="action_buttons"
            >
                <LsActionButton
                    v-for="action in requiredServiceActions"
                    :key="action.action"
                    v-bind="action"
                    :service="requiredService"
                />
            </div>
            <router-view v-else />
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { lsErrorService } from 'ls-vue-common';
import LsTemplatedLoading from '@/components/LsTemplatedLoading/LsTemplatedLoading.vue';
import LsServiceRecOrReqDetails from '@/components/LsServiceRecOrReqDetails/LsServiceRecOrReqDetails.vue';
import LsActionButton from '@/components/LsActionButton/LsActionButton.vue';
import { apolloClient } from '@/vue-apollo';
import RequiredService from '@/graphql/queries/RequiredService.gql';
import AllRecentAndCurrentServices from '@/graphql/queries/AllRecentAndCurrentServices.gql';
import DEFAULT_ALL_RECENT_AND_CURRENT_SERVICES from '@/graphql/queries/AllRecentAndCurrentServices.defaults';
import RequiredServiceActions from '@/graphql/queries/RequiredServiceActions.gql';

export default {
    name: 'RequiredServiceView',
    components: {
        LsServiceRecOrReqDetails,
        LsTemplatedLoading,
        LsActionButton,
    },
    data() {
        const variables = {
            customer_id: _.toNumber(this.$route.params.customer_id),
            property_id: _.toNumber(this.$route.params.property_id),
            id: _.toNumber(this.$route.params.requiredService_id),
        };

        let allRecentAndCurrentServices = DEFAULT_ALL_RECENT_AND_CURRENT_SERVICES;
        try {
            const result = apolloClient.readQuery({
                query: AllRecentAndCurrentServices,
                variables,
            });
            if (result && result.allRecentAndCurrentServices) {
                allRecentAndCurrentServices = result.allRecentAndCurrentServices;
            }
        } catch (e) {
            // Cache miss on deep-link
        }

        return {
            loading: 0,
            requiredService: {},
            requiredServiceActions: [],
            allRecentAndCurrentServices: _.concat(
                allRecentAndCurrentServices.schedules || [],
                allRecentAndCurrentServices.recommendations || [],
                allRecentAndCurrentServices.requiredServices || []
            ),
            variables,
        };
    },
    apollo: {
        requiredService: {
            query: RequiredService,
            variables() {
                return this.variables;
            },
            result({ data, loading }) {
                if (!loading) {
                    const {
                        requiredService,
                        price,
                        commission,
                        payout,
                        total_amount,
                        tax_amount,
                    } = data.requiredService;

                    this.requiredService = {
                        ...requiredService,
                        price,
                        commission,
                        payout,
                        total_amount,
                        tax_amount,
                    };
                }
            },
            error(error) {
                lsErrorService.log({ error });
            },
            loadingKey: 'loading',
        },
        requiredServiceActions: {
            query: RequiredServiceActions,
            variables() {
                return this.variables;
            },
            error(error) {
                lsErrorService.log({ error });
            },
            fetchPolicy: 'cache-and-network',
            loadingKey: 'loading',
        },
    },
    computed: {
        routeName() {
            return this.$route.name;
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name === 'requiredService') {
            this.$apollo.queries.requiredServiceActions.refetch(this.variables);
        }
        next();
    },
};
</script>

<style lang="scss" scoped>
.ls-required_service-view--columns {
    display: flex;
    flex-direction: row;
}

.ls-required_service-view--details {
    width: 370px;
    margin-right: 20px;
    height: max-content;
}

.ls-required_service-view--buttons {
    > div {
        width: 370px;
    }

    > :nth-child(n + 2) {
        margin-top: 20px;
    }

    @media (min-width: $desktop) {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        height: max-content;
        > :nth-child(n + 2) {
            margin-top: 0;
        }
        > :nth-child(n + 3) {
            margin-top: 20px;
        }
        > :nth-child(even) {
            margin-left: 20px;
        }
    }
}
</style>
